import { useState } from 'react'
const useLoadingState = () => {
    const [loading, setLoading] = useState(true)
    return { loading, setLoading }
}
export default useLoadingState